import { render, staticRenderFns } from "./ExcFooter.vue?vue&type=template&id=43126ca7&scoped=true&"
import script from "./ExcFooter.vue?vue&type=script&lang=js&"
export * from "./ExcFooter.vue?vue&type=script&lang=js&"
import style0 from "./ExcFooter.vue?vue&type=style&index=0&id=43126ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43126ca7",
  null
  
)

export default component.exports